import React from 'react';
import './IndustryPage.css';

const SERVICES = [
  {
    title: 'Kalite yönetim sistemleri çalışmaları',
    desc: 'Kurumların kalite yönetim sistemlerinin kurulması, iyileştirilmesi ve belgelendirme süreçlerine hazırlık konularında rehberlik ve destek. ISO 9001 ve diğer yönetim sistemi standartlarına uyum çalışmalarında uzman yönlendirmesi.',
  },
  {
    title: 'Uzman yönlendirme',
    desc: 'Kalite mühendisliği, denetim ve süreç iyileştirme alanlarında deneyimli uzmanlara erişim. Kurumların ihtiyaç duyduğu konularda doğru uzmanla eşleştirme ve proje bazlı danışmanlık yönlendirmesi.',
  },
  {
    title: 'Eğitim ve seminerler',
    desc: 'Kalite yönetimi, iç denetim, süreç yönetimi ve ilgili konularda kurumsal veya açık eğitimler ile seminerler. Sanayi temsilcilerinin mesleki gelişimine yönelik özelleştirilmiş programlar.',
  },
  {
    title: 'Kurumsal gelişim çalışmaları',
    desc: 'Kalite kültürünün yerleşmesi, süreç iyileştirme ve kurumsal performans yönetimi konularında proje bazlı iş birlikleri. Küçük ve orta ölçekli işletmelerden büyük sanayi kuruluşlarına kadar farklı ölçeklerde destek.',
  },
];

const BENEFITS = [
  'Kalite yönetim sistemlerinde güncel ve uygulanabilir rehberlik',
  'Deneyimli kalite mühendisleri ve uzmanlara erişim',
  'Eğitim ve bilgilendirme imkânları',
  'Mesleki standartlara uyum konusunda destek',
];

const IndustryPage = () => {
  return (
    <div className="industry-page page-wrapper">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Sanayi İş Birlikleri</h1>
          <p className="page-hero-subtitle">
            Sanayi ile iş birliği kapsamında sunulan hizmetler ve çalışma alanları.
          </p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <section className="content-section">
            <p className="intro">
              TKMB, sanayi ile iş birliği kurmak ve kalite kültürünün yaygınlaşmasına katkı sağlamak amacıyla
              kalite yönetim sistemleri, uzman yönlendirme, eğitim ve kurumsal gelişim alanlarında çalışmalar yürütmektedir.
              Aşağıda bu hizmet alanları ve sanayiye sağlanan faydalar özetlenmektedir.
            </p>
          </section>

          <section className="content-section">
            <h2>Hizmet Alanları</h2>
            <div className="industry-cards">
              {SERVICES.map((item, index) => (
                <div key={index} className="industry-card">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="content-section">
            <h2>Sanayiye Sağlanan Faydalar</h2>
            <p className="section-lead">
              TKMB sanayi iş birlikleri kapsamında aşağıdaki faydalar hedeflenmektedir:
            </p>
            <ul className="industry-benefits-list">
              {BENEFITS.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="content-section">
            <p>
              İş birliği talepleri ve özelleştirilmiş eğitim veya danışmanlık ihtiyaçları için kurumlar
              TKMB ile iletişime geçerek ihtiyaç analizi ve uygun çözüm önerileri alabilir.
            </p>
          </section>

          <p className="contact-cta">
            Sanayi iş birlikleri ve hizmetler hakkında bilgi için{' '}
            <a href="mailto:info@tkmb.org">info@tkmb.org</a> adresinden bizimle iletişime geçebilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IndustryPage;
